function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm0 9.166A.836.836 0 019.167 10V6.667c0-.459.375-.834.833-.834.458 0 .833.375.833.834V10a.836.836 0 01-.833.833zm.833 3.334H9.167V12.5h1.666v1.667z",
  id: "exclamation_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#exclamation_svg__a",
  transform: "translate(-1 -1)",
  fillRule: "evenodd"
});

function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgExclamation;